// "Mehr ▾" - seltene Aktionen einer Werkzeugleiste an einer Stelle.
//
// Angelegt am 23.09.2026 fuer die Vorlagen: Dort standen sieben gleich
// gewichtete Knoepfe nebeneinander (Original, EZ/JZ Sync, Zuruecksetzen,
// Speichern, Versionen, Exportieren, Beispiel-Paragraph). Taeglich gebraucht
// werden Speichern und Versionen; der Rest liegt jetzt hier.
//
// eintraege: [{ key, label, icon, onClick, disabled, title, gefahr }]

import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { T, knopfStil } from '../../lib/designTokens';

export default function MehrMenue({ eintraege, beschriftung = 'Mehr', stil = null }) {
  const [offen, setOffen] = useState(false);
  const huelle = useRef(null);
  const ausloeser = useRef(null);

  // Schliesst das Menue und gibt den Fokus an "Mehr" zurueck - sonst landete
  // er mit dem ausgeblendeten Eintrag auf <body> (Code-Review 23.09.2026).
  const schliessen = () => {
    setOffen(false);
    ausloeser.current?.focus();
  };

  useEffect(() => {
    if (!offen) return undefined;
    const draussen = (e) => { if (huelle.current && !huelle.current.contains(e.target)) setOffen(false); };
    const taste = (e) => {
      if (e.key !== 'Escape') return;
      setOffen(false);
      ausloeser.current?.focus();
    };
    document.addEventListener('mousedown', draussen);
    document.addEventListener('keydown', taste);
    return () => {
      document.removeEventListener('mousedown', draussen);
      document.removeEventListener('keydown', taste);
    };
  }, [offen]);

  const sichtbar = eintraege.filter(Boolean);
  if (!sichtbar.length) return null;

  return (
    <div ref={huelle} style={{ position: 'relative' }}>
      <button ref={ausloeser} type="button" onClick={() => setOffen((v) => !v)} aria-haspopup="menu" aria-expanded={offen}
        style={{ ...knopfStil(offen), ...(stil || {}) }}>
        {beschriftung}
        <ChevronDown size={13} style={{ transform: offen ? 'rotate(180deg)' : 'none', transition: 'transform 120ms' }} />
      </button>
      {offen ? (
        <div role="menu" style={{
          position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 60, minWidth: 250,
          whiteSpace: 'nowrap',
          background: T.flaeche, border: `1px solid ${T.randWeich}`, borderRadius: T.rKarte,
          boxShadow: '0 12px 32px rgba(18, 42, 92, 0.14)', padding: 5,
        }}>
          {sichtbar.map(({ key, label, icon: Icon, onClick, disabled, title, gefahr }) => (
            <button key={key} type="button" role="menuitem" disabled={disabled} title={title}
              onClick={() => { schliessen(); onClick(); }}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px',
                border: 'none', borderRadius: T.rChip, background: 'transparent', textAlign: 'left',
                fontSize: T.tSm, fontWeight: 600, color: gefahr ? T.gefahr : T.ink,
                cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.45 : 1,
              }}
              onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = T.grund; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              {Icon ? <Icon size={14} color={gefahr ? T.gefahr : T.muted} /> : null}
              {label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
